import React from 'react';
import { useTranslation } from 'react-i18next';

import { LabeledSelect } from '../Input/LabeledSelect';

const UnregisteredDrugRequestTypeSelect = ({ allowClear = true, disabled, ...props }) => {
  const [ t ] = useTranslation();

  return (
    <LabeledSelect
      placeholder={ t('fields.choose') }
      { ...props }
      disabled={ disabled }
      allowClear={ allowClear }
      options={ [
        { value: 2, text: t('fields.requestType.paid') },
        { value: 1, text: t('fields.requestType.free') }
      ] }
    />
  );
};

export default UnregisteredDrugRequestTypeSelect;
